import {
  Image,
  Card,
  Button,
  Carousel,
  Typography,
  theme,
  Flex,
  Row,
  Col,
  List,
  Grid,
  Form,
  Checkbox,
  Input,
} from "antd";
import { Content } from "antd/es/layout/layout";
import {
  ArrowRightOutlined,
  LockOutlined,
  UserOutlined,
} from "@ant-design/icons";
import "./login-component.scss";
import notification2 from "assets/images/notification2.jpg"; // Adjust the path accordingly
import announcements1 from "assets/images/announcements1.png"; // Adjust the path accordingly
import announcements2 from "assets/images/announcements2.png"; // Adjust the path accordingly
import img1 from "assets/images/img1.png";
import img2 from "assets/images/img2.png";
import img3 from "assets/images/img3.png";
import img4 from "assets/images/img4.png";
import img5 from "assets/images/img5.png";
import img6 from "assets/images/img6.png";
import img7 from "assets/images/img7.png";
import imgv1 from "assets/images/v1.svg";
import imgv2 from "assets/images/v2.svg";
import imgv3 from "assets/images/v3.svg";
import imgv4 from "assets/images/v4.svg";
import test1 from "assets/images/test1.png";
import test2 from "assets/images/test2.png";
import appmobile from "assets/images/app_mobile.png";
import checkIconText from "assets/images/red-check.svg";
import appStore from "assets/images/app-store.png";
import googlePlay from "assets/images/google-pay.png";
import slider1 from "assets/images/slider1.jpg";
import pattern from "assets/images/pattern.png";
import { useNavigate } from "react-router-dom";
const { Title, Text } = Typography;
const { Meta } = Card;
const { useToken } = theme;

function LoginComponent() {
  const screens = Grid.useBreakpoint();
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: !screens.xs,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        arrows: false,
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
    className: "custom-slider",
  };


  const {
    token: { colorPrimary },
  } = useToken();

  const onFinish = (values: any) => {
    console.log("Received values of form: ", values);
  };

  const navigate = useNavigate();

  const afterLogin = () => {
    navigate('/home');
  }

  return (
    <Content>
      <Carousel className="top-header-slider">
        <div>
          <div
            className="coverImage"
            style={{ backgroundImage: `url(${slider1})` }}
          >
            <div className="container position-relative">
              <div className="formUI">
                <Card className="loginForm" title="Sign In Your ID">
                  <Form
                    name="login"
                    initialValues={{
                      remember: true,
                    }}
                    style={{
                      maxWidth: 360,
                    }}
                    onFinish={onFinish}
                  >
                    <Form.Item
                      name="username"
                      rules={[
                        {
                          required: true,
                          message: "Please input your Username!",
                        },
                      ]}
                    >
                      <Input
                        size="large"
                        prefix={<UserOutlined />}
                        placeholder="Username"
                      />
                    </Form.Item>
                    <Form.Item
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: "Please input your Password!",
                        },
                      ]}
                    >
                      <Input
                        size="large"
                        prefix={<LockOutlined />}
                        type="password"
                        placeholder="Password"
                      />
                    </Form.Item>
                    <Form.Item>
                      <Flex justify="space-between" align="center">
                        <Form.Item
                          name="remember"
                          valuePropName="checked"
                          noStyle
                        >
                          <Checkbox>Remember me</Checkbox>
                        </Form.Item>
                        <Button color="primary" variant="link">
                          Forgot password
                        </Button>
                      </Flex>
                    </Form.Item>

                    <Form.Item>
                      <Button
                        block
                        danger
                        type="primary"
                        htmlType="submit"
                        size={"large"}
                        onClick={afterLogin}
                      >
                        Log in
                      </Button>
                    </Form.Item>
                  </Form>
                </Card>
              </div>
            </div>
          </div>

          {/* <Image src={slider1} preview={false} /> */}
        </div>
      </Carousel>
      <div className="custom-carousel-container mt-100">
        <div className="container">
          <Typography.Title level={1} className="mb-5">
            Notifications
          </Typography.Title>
          <Carousel
            {...settings}
            dotPosition="bottom"
            className="product-slider"
          >
            <div>
              <Card hoverable cover={<img alt="example" src={notification2} />}>
                <Flex gap={"large"} vertical align={"start"}>
                  <Meta
                    title="Important Update : Global Village"
                    description="will not only be faultlessly served with the Destination Management services of high-"
                  />

                  <Button
                    type="primary"
                    shape="round"
                    iconPosition={"end"}
                    icon={<ArrowRightOutlined />}
                  >
                    Read More
                  </Button>
                </Flex>
              </Card>
            </div>
            <div>
              <Card hoverable cover={<img alt="example" src={notification2} />}>
                <Flex gap={"large"} vertical align={"start"}>
                  <Meta
                    title="Important Update : Global Village"
                    description="will not only be faultlessly served with the Destination Management services of high-"
                  />

                  <Button
                    type="primary"
                    shape="round"
                    iconPosition={"end"}
                    icon={<ArrowRightOutlined />}
                  >
                    Read More
                  </Button>
                </Flex>
              </Card>
            </div>
            <div>
              <Card hoverable cover={<img alt="example" src={notification2} />}>
                <Flex gap={"large"} vertical align={"start"}>
                  <Meta
                    title="Important Update : Global Village"
                    description="will not only be faultlessly served with the Destination Management services of high-"
                  />

                  <Button
                    type="primary"
                    shape="round"
                    iconPosition={"end"}
                    icon={<ArrowRightOutlined />}
                  >
                    Read More
                  </Button>
                </Flex>
              </Card>
            </div>

            <div>
              <Card hoverable cover={<img alt="example" src={notification2} />}>
                <Flex gap={"large"} vertical align={"start"}>
                  <Meta
                    title="Important Update : Global Village"
                    description="will not only be faultlessly served with the Destination Management services of high-"
                  />

                  <Button
                    type="primary"
                    shape="round"
                    iconPosition={"end"}
                    icon={<ArrowRightOutlined />}
                  >
                    Read More
                  </Button>
                </Flex>
              </Card>
            </div>

            <div>
              <Card hoverable cover={<img alt="example" src={notification2} />}>
                <Flex gap={"large"} vertical align={"start"}>
                  <Meta
                    title="Important Update : Global Village"
                    description="will not only be faultlessly served with the Destination Management services of high-"
                  />

                  <Button
                    type="primary"
                    shape="round"
                    iconPosition={"end"}
                    icon={<ArrowRightOutlined />}
                  >
                    Read More
                  </Button>
                </Flex>
              </Card>
            </div>

            <div>
              <Card hoverable cover={<img alt="example" src={notification2} />}>
                <Flex gap={"large"} vertical align={"start"}>
                  <Meta
                    title="Important Update : Global Village"
                    description="will not only be faultlessly served with the Destination Management services of high-"
                  />

                  <Button
                    type="primary"
                    shape="round"
                    iconPosition={"end"}
                    icon={<ArrowRightOutlined />}
                  >
                    Read More
                  </Button>
                </Flex>
              </Card>
            </div>
            {/* Add more product items */}
          </Carousel>
        </div>
        <div className="container">
          <Row gutter={[16, 16]} className="mt-100">
            <Col span={24}>
              <Typography.Title level={1} className="text-center mb-0 mt-0">
                Efficient Tourism &nbsp;
                <Text type="danger" className="header-font-title">
                  Announcements
                </Text>
              </Typography.Title>
              <Text type="secondary" className="text-center d-block">
                Weekday Tickets are not valid on UAE public holidays.
              </Text>
            </Col>
          </Row>
        </div>
        <div className="container">
          <Row gutter={[16, 16]} className="mt-5">
            <Col xs={24} sm={24} md={12} lg={12}>
              <Card className="annulment-card border-radius-20" bordered>
                <Row
                  gutter={[16, 16]}
                  style={{
                    flexDirection: screens.xs ? "column" : "row", // Column on xs, row on larger screens
                  }}
                >
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Image
                      src={announcements1}
                      preview={false}
                      width={"100%"}
                      className="announcementImg"
                    />
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Flex
                      gap="large"
                      justify={"space-between"}
                      align="start"
                      className="py-4 px-3 text-body-announe"
                      vertical
                    >
                      <div>
                        <Typography.Title level={4} className="mt-0">
                          Rayna Roadshow July 2024
                        </Typography.Title>
                        <Text type="secondary">
                          RaynaTours wraps up a successful ATM Dubai 2024.will
                          not only be faultlessly served with the Destination
                          Management services of high-
                        </Text>
                      </div>
                      <Button
                        type="primary"
                        shape="round"
                        danger
                        iconPosition={"end"}
                        icon={<ArrowRightOutlined />}
                      >
                        Read More
                      </Button>
                    </Flex>
                  </Col>
                </Row>
              </Card>
            </Col>
            <Col xs={24} sm={24} md={12} lg={12}>
              <Card className="annulment-card border-radius-20" bordered>
                <Row
                  gutter={[16, 16]}
                  style={{
                    flexDirection: screens.xs ? "column" : "row", // Column on xs, row on larger screens
                  }}
                >
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Image
                      width={"100%"}
                      src={announcements2}
                      className="announcementImg"
                      preview={false}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={12}>
                    <Flex
                      gap="large"
                      justify={"space-between"}
                      align="start"
                      className="py-4 px-3 text-body-announe"
                      vertical
                    >
                      <div>
                        <Typography.Title level={4} className="mt-0">
                          Rayna Roadshow July 2024
                        </Typography.Title>
                        <Text type="secondary">
                          RaynaTours wraps up a successful ATM Dubai 2024.will
                          not only be faultlessly served with the Destination
                          Management services of high-
                        </Text>
                      </div>
                      <Button
                        type="primary"
                        shape="round"
                        danger
                        iconPosition={"end"}
                        icon={<ArrowRightOutlined />}
                      >
                        Read More
                      </Button>
                    </Flex>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>

        <div className="container">
          <Row gutter={[16, 16]} className="mt-100">
            <Col xs={24} sm={12} md={12} lg={9}>
              <div className="position-relative image-card">
                <Image src={img1} preview={false} />
                <div className="position-absolute image-card-text">
                  <Typography.Title level={2} className="mt-0 mb-0">
                    400000+
                  </Typography.Title>
                  <Text type="secondary">Hotels & Apartments Worldwide</Text>
                </div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={5}>
              <div className="position-relative image-card">
                <Image src={img2} preview={false} />
                <div className="position-absolute image-card-text centered-text">
                  <Typography.Title level={3} className="mt-0 mb-0">
                    10000+
                  </Typography.Title>
                  <Text type="secondary">
                    Sightseeing items and Tours Covering 500 cities
                  </Text>
                </div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={5}>
              <div className="position-relative image-card">
                <Image src={img3} preview={false} />
                <div className="position-absolute image-card-text centered-text">
                  <Typography.Title level={3} className="mt-0 mb-0">
                    20,000+
                  </Typography.Title>
                  <Text type="secondary">Active User's Worldwide</Text>
                </div>
              </div>
            </Col>
            <Col xs={24} sm={12} md={12} lg={5}>
              <div className="position-relative image-card">
                <Image src={img4} preview={false} />
                <div className="position-absolute image-card-text centered-text">
                  <Typography.Title
                    level={3}
                    className="mt-0 mb-0 centered-text"
                  >
                    100000+
                  </Typography.Title>
                  <Text type="secondary">
                    Sightseeing items and Tours Covering 500 cities
                  </Text>
                </div>
              </div>
            </Col>
          </Row>
        </div>

        <div className="container">
          <Row
            gutter={[32, 48]}
            justify="space-between"
            className="go-together mt-100"
          >
            <Col xs={24} sm={24} md={12} lg={11} className="position-relative">
              <Card
                className="border-radius-20 colarge-one"
                cover={<img alt="example" src={img5} />}
              ></Card>
              <Card
                className="border-radius-20 colarge-two"
                cover={<img alt="example" src={img6} />}
              ></Card>
              <Card
                className="border-radius-20 colarge-three"
                cover={<img alt="example" src={img7} />}
              ></Card>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12}>
              <Typography.Title
                level={2}
                className="mt-0 mb-0"
              >
                Lets Go Together
              </Typography.Title>

              <Typography.Title level={1} className="mt-0 mb-4">
                Why Book With Us?
              </Typography.Title>

              <List itemLayout="horizontal" className="list-view">
                <List.Item>
                  <List.Item.Meta
                    avatar={<img src={imgv1} />}
                    title={
                      <Typography.Text>
                        {"Free & Quick Registration"}
                      </Typography.Text>
                    }
                    description="Agent who fulfills the criteria can register as an Agent. wherein the agent can login and access the services he wants to book."
                  />
                </List.Item>
                <List.Item>
                  <List.Item.Meta
                    avatar={<img src={imgv4} />}
                    title={
                      <Typography.Text>
                        {"Best Price Guarantee"}
                      </Typography.Text>
                    }
                    description="Best Price Guarantee promises our esteemed clients that they will not only be faultlessly served with the Destination Management services"
                  />
                </List.Item>
                <List.Item>
                  <List.Item.Meta
                    avatar={<img src={imgv3} />}
                    title={
                      <Typography.Text>
                        {"Easy Online Transaction"}
                      </Typography.Text>
                    }
                    description="Reliability and safety of our customers' personal data are top of mind at Rayna Tours, and that's why our sophisticated online portal is thoroughly"
                  />
                </List.Item>
                <List.Item>
                  <List.Item.Meta
                    avatar={<img src={imgv2} />}
                    title={
                      <Typography.Text>
                        {"Secure Online Transaction"}
                      </Typography.Text>
                    }
                    description="Our online payment system is secure! In fact it encrypts your payment information to protect you against fraud and unauthorized transactions."
                  />
                </List.Item>
              </List>

              <Button
                type="primary"
                shape="round"
                iconPosition={"end"}
                icon={<ArrowRightOutlined />}
                className="mt-5"
                danger
              >
                Read More
              </Button>
            </Col>
          </Row>
        </div>

        <div
          className="testimonial mt-100"
          style={{
            backgroundImage: `url(${pattern})`,
          }}
        >
          <div className="container">
            <Row gutter={[32, 48]} justify="space-between">
              <Col
                xs={24}
                sm={24}
                md={12}
                lg={12}
                className="position-relative"
              >
                <Flex gap="middle" align="center">
                  <Card
                    className="border-radius-20 shape-one"
                    cover={<img alt="example" src={test1} />}
                  ></Card>
                  <Card
                    className="border-radius-20 shape-two"
                    cover={<img alt="example" src={test2} />}
                  ></Card>
                </Flex>
              </Col>

              <Col xs={24} sm={24} md={12} lg={11}>
                <Typography.Title
                  level={2}
                  className="mt-0 mb-0"
                >
                  Testimonial
                </Typography.Title>

                <Typography.Title level={1}
                  className="mt-0 mb-0">
                  What Client Say
                </Typography.Title>

                <Text>
                  "Throughout the interior, eco-friendly materials like
                  reclaimed wood, bamboo flooring, and recycled glass
                  countertops create a luxurious yet interior eco-friendly
                  materials like reclaimed wood, sustainable ambiance."
                </Text>
                <Title level={4} className="primary-color mb-0">
                  Sarah Rahman
                </Title>
                <Title level={5} type="danger" className="mt-0">
                  Travel
                </Title>
              </Col>
            </Row>
          </div>
        </div>

        <div className="container">
          <Row gutter={[32, 48]} justify="space-between" className="mt-100">
            <Col xs={24} sm={24} md={12} lg={11} className="position-relative">
              <Flex gap="middle" align="center">
                <Card
                  className="border-radius-20"
                  cover={<img alt="example" src={appmobile} />}
                ></Card>
              </Flex>
            </Col>

            <Col xs={24} sm={24} md={12} lg={11}>
              <Typography.Title level={1} className="mt-0">
                Get 5% off on your First app booking Travel with us
              </Typography.Title>

              <Text>
                We don’t just work with concrete and steel. We work with
                peopleWe are Approachable, with even our highest work work with
                concrete and steel. We work with people
              </Text>
              <Flex gap="middle" align="center" className="mt-4 mb-2">
                <Image src={checkIconText} preview={false} />
                <Typography.Title level={5} className="mt-0 mb-0 primary-dark">
                  Download Efficient Mobile App for Android or Iphone.
                </Typography.Title>
              </Flex>
              <Flex gap="middle" align="center" className="mb-2">
                <Image src={checkIconText} preview={false} />
                <Typography.Title level={5} className="mt-0 mb-0 primary-dark">
                  Now you can check your booking status anytime, anywhere!
                </Typography.Title>
              </Flex>
              <Flex gap="middle" align="center" className="">
                <Image src={checkIconText} preview={false} />
                <Typography.Title level={5} className="mt-0 mb-0 primary-dark">
                  Quicker, faster, easier!
                </Typography.Title>
              </Flex>

              <Flex gap="small" align="center" className="mb-2 mt-5">
                <Button
                  type="link"
                  href="https://ant.design/index-cn"
                  className="p-0"
                >
                  <Image src={appStore} preview={false} />
                </Button>
                <Button
                  type="link"
                  href="https://ant.design/index-cn"
                  className="p-0"
                >
                  <Image src={googlePlay} preview={false} />
                </Button>
              </Flex>
            </Col>
          </Row>
        </div>
      </div>
    </Content>
  );
}

export default LoginComponent;